/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { toAbsoluteUrl } from '../../../helpers'
import { AsideMenu } from './AsideMenu'
import { useAuth } from '../../../../app/contexts/AuthProvider'
import { useState } from 'react'

const AsideDefault: React.FC = () => {
  const { config, classes } = useLayout()
  const { signOut } = useAuth()
  const { aside } = config
  const [itensRodape, setItensRodape] = useState<JSX.Element[]>([]);

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
      style={{ backgroundColor: '#00B7A1' }}
    >
      {/* begin::Brand */}
      <div style={{ backgroundColor: '#FFF' }}>
        <div style={{ borderRadius: '0px 45px 0 0', backgroundColor: '#00B7A1' }} className='aside-logo flex-column-auto pt-11' id='kt_aside_logo'>
          {aside.theme === 'light' && (
            <Link to='/'>
              <img
                alt='Logo'
                className='logo'
                style={{ width: '99%' }}
                src={toAbsoluteUrl('/media/logos/logo-branco.png')}
              />
            </Link>
          )}

          {/* begin::Aside toggler */}
          {aside.minimize && (
            <div
              id='kt_aside_toggle'
              className='btn btn-icon aside-toggle'
              data-kt-toggle='true'
              data-kt-toggle-state='active'
              data-kt-toggle-target='body'
              data-kt-toggle-name='aside-minimize'
              style={{
                marginLeft: '6%'
              }}
            >

              <i className="fa fa-angle-double-left text-white rotate-180"></i>
            </div>
          )}
          {/* end::Aside toggler */}
        </div>
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} setItensAdicionais={setItensRodape} />
      </div>
      {/* end::Aside menu */}

      {/* begin::Footer */}
      <div className='aside-footer flex-column-auto pt-5 pb-7 px-5' id='kt_aside_footer'>
        { itensRodape.map((x, index) => <div key={index}>{ x }</div>) }
        <a
          onClick={signOut}
          target='_blank'
          className='btn btn-custom btn-primario w-60'
          data-bs-toggle='tooltip'
          data-bs-trigger='hover'
          data-bs-dismiss-='click'
          title='Check out the complete documentation with over 100 components'
          style={{
            border: 'white 1px solid',
            borderRadius: '100px',
            marginTop: '7px'
          }}
        >
          <i className="fas fa-sign-out-alt icon-xl text-white text-center ml-1"
            style={{
              fontSize: '1.6rem',
              marginLeft: '7px'
            }}
          ></i>
          <span className='btn-label'> Desconectar</span>
        </a>
      </div>
      {/* end::Footer */}
    </div>
  )
}

export { AsideDefault }
